import React, { FC } from "react";
import "./styles.scss";
import { IAnyProps } from "../Types/Types";

interface IProps {
  iconType: string;
  href: string;
  companyName: string;
  companyId: string;
  size?: string;
}

const SocialIcon: FC<IProps> = ({
  iconType,
  href,
  companyName,
  companyId,
  size = undefined,
}: IProps) => {
  // if (size) {
  //   style = { height: size, width: size };
  // }

  return (
    <div>
      {iconType === "linkedin" && (
        <LinkedinSocialIcon
          href={href}
          companyName={companyName}
          companyId={companyId}
          size={size}
        />
      )}
      {iconType === "twitter" && (
        <TwitterSocialIcon
          href={href}
          companyName={companyName}
          companyId={companyId}
        />
      )}
      {iconType === "instagram" && (
        <InstagramSocialIcon
          href={href}
          companyName={companyName}
          companyId={companyId}
        />
      )}
      {iconType === "telegram" && (
        <TelegramSocialIcon
          href={href}
          companyName={companyName}
          companyId={companyId}
        />
      )}
      {iconType === "github" && (
        <GithubSocialIcon
          href={href}
          companyName={companyName}
          companyId={companyId}
        />
      )}
      {iconType === "facebook" && (
        <FacebookSocialIcon
          href={href}
          companyName={companyName}
          companyId={companyId}
        />
      )}
      {iconType === "medium" && (
        <MediumSocialIcon
          href={href}
          companyName={companyName}
          companyId={companyId}
        />
      )}
      {iconType === "reddit" && (
        <RedditSocialIcon
          href={href}
          companyName={companyName}
          companyId={companyId}
        />
      )}
      {iconType === "discord" && (
        <DiscordSocialIcon
          href={href}
          companyName={companyName}
          companyId={companyId}
        />
      )}
      {iconType === "youtube" && (
        <YoutubeSocialIcon
          href={href}
          companyName={companyName}
          companyId={companyId}
        />
      )}
      {iconType === "angellist" && (
        <AngellistSocialIcon
          href={href}
          companyName={companyName}
          companyId={companyId}
        />
      )}
      {iconType === "crunchbase" && (
        <CrunchbaseSocialIcon
          href={href}
          companyName={companyName}
          companyId={companyId}
        />
      )}
    </div>
  );
};

SocialIcon.propTypes = {};

export default SocialIcon;

const LinkedinSocialIcon = ({ href, companyName, companyId, size }: IAnyProps) => {
  return (
    <span>
      <a
        className={`ps-logo--linkedin-logo ${
          size === "small" ? "ps-logo--small" : ""
        }`}
        target="_blank"
        rel="noreferrer"
        href={href}
        data-company-name={companyName}
        data-project-id={companyId}
        data-social-network="linkedin"
        data-tracking-id="company-social"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
        >
          <path
            id="linkedin-svg-path"
            data-name="Path 50"
            d="M481.932,36.5H464.888a1.46,1.46,0,0,0-1.476,1.441V55.057a1.461,1.461,0,0,0,1.476,1.443h17.043a1.463,1.463,0,0,0,1.48-1.443V37.941A1.463,1.463,0,0,0,481.932,36.5ZM469.344,53.543h-2.966V44h2.966Zm-1.483-10.849a1.72,1.72,0,1,1,1.719-1.72A1.72,1.72,0,0,1,467.861,42.693Zm12.593,10.849H477.49V48.9c0-1.107-.02-2.531-1.541-2.531-1.543,0-1.781,1.206-1.781,2.451v4.722H471.2V44h2.845v1.3h.04a3.117,3.117,0,0,1,2.807-1.542c3,0,3.558,1.977,3.558,4.547Z"
            transform="translate(-463.412 -36.5)"
            fill="#777b7f"
            opacity="0.7"
          ></path>
        </svg>
      </a>
    </span>
  );
};

const TwitterSocialIcon = ({ href, companyName, companyId }: IAnyProps) => {
  return (
    <span>
      <a
        className="ps-logo--twitter-logo"
        target="_blank"
        rel="noreferrer"
        href={href}
        data-company-name={companyName}
        data-project-id={companyId}
        data-social-network="twitter"
        data-tracking-id="company-social"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="16"
          viewBox="0 0 20 16"
        >
          <path
            id="twitter-svg-path"
            data-name="Path 25"
            d="M70,70.627a8.307,8.307,0,0,1-2.357.636,4.064,4.064,0,0,0,1.8-2.235,8.291,8.291,0,0,1-2.606.98,4.129,4.129,0,0,0-2.995-1.275,4.072,4.072,0,0,0-4.1,4.039,3.993,3.993,0,0,0,.106.92,11.711,11.711,0,0,1-8.457-4.22,3.972,3.972,0,0,0-.556,2.031,4.021,4.021,0,0,0,1.825,3.362A4.136,4.136,0,0,1,50.8,74.36c0,.017,0,.034,0,.051a4.058,4.058,0,0,0,3.291,3.961,4.177,4.177,0,0,1-1.853.069,4.1,4.1,0,0,0,3.833,2.805,8.315,8.315,0,0,1-5.1,1.729A8.452,8.452,0,0,1,50,82.918a11.748,11.748,0,0,0,6.29,1.815A11.5,11.5,0,0,0,67.964,73.241q0-.263-.012-.523A8.266,8.266,0,0,0,70,70.627Z"
            transform="translate(-50 -68.733)"
            fill="#A0A3A6"
          ></path>
        </svg>
      </a>
    </span>
  );
};

const InstagramSocialIcon = ({ href, companyName, companyId }: IAnyProps) => {
  return (
    <span>
      <a
        className="ps-logo--instagram-logo"
        target="_blank"
        rel="noreferrer"
        href={href}
        data-company-name={companyName}
        data-project-id={companyId}
        data-social-network="instagram"
        data-tracking-id="company-social"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="feather feather-instagram"
        >
          <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
          <path
            id="instagram-svg-path"
            d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"
          ></path>
          <line x1="17.5" y1="6.5" x2="17.5" y2="6.5"></line>
        </svg>
      </a>
    </span>
  );
};

const TelegramSocialIcon = ({ href, companyName, companyId }: IAnyProps) => {
  return (
    <span>
      <a
        className="ps-logo--telegram-logo"
        target="_blank"
        rel="noreferrer"
        href={href}
        data-company-name={companyName}
        data-project-id={companyId}
        data-social-network="telegram"
        data-tracking-id="company-social"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <g
            id="Group_205"
            data-name="Group 205"
            transform="translate(106.599 106.598)"
          >
            <circle
              id="telegram-svg-path"
              data-name="Ellipse 17"
              cx="12"
              cy="12"
              r="12"
              transform="translate(-106.599 -82.598) rotate(-90)"
              fill="#a0a3a6"
            />
            <g
              id="Group_205-2"
              data-name="Group 205"
              transform="translate(-101.969 -99.569)"
            >
              <path
                id="Path_26"
                data-name="Path 26"
                d="M107.678,144.671l-1.95,9.829a.722.722,0,0,1-1.022.354l-4.5-3.449-1.636-.791-2.754-.927s-.423-.15-.463-.477.477-.5.477-.5l10.947-4.294S107.678,144.017,107.678,144.671Z"
                transform="translate(-95.352 -144.294)"
                fill="#fff"
              />
              <path
                id="Path_27"
                data-name="Path 27"
                d="M175.364,201.746s-.131-.012-.295-.53-1-3.245-1-3.245l6.612-4.2s.382-.232.368,0c0,0,.068.041-.136.232s-5.194,4.676-5.194,4.676"
                transform="translate(-170.854 -191.65)"
                fill="#cecece"
              />
              <path
                id="Path_28"
                data-name="Path 28"
                d="M207.69,318.822l-1.779,1.622a.312.312,0,0,1-.291.039l.341-3.014"
                transform="translate(-201.109 -310.387)"
                fill="#bcbcbc"
              />
            </g>
          </g>
        </svg>
      </a>
    </span>
  );
};

const GithubSocialIcon = ({ href, companyName, companyId }: IAnyProps) => {
  return (
    <span>
      <a
        className="ps-logo--github-logo"
        target="_blank"
        rel="noreferrer"
        href={href}
        data-company-name={companyName}
        data-project-id={companyId}
        data-social-network="github"
        data-tracking-id="company-social"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="23.363"
          viewBox="0 0 24 23.363"
        >
          <path
            id="github-svg-path"
            data-name="Path 57"
            d="M-1098.076,44.932a12,12,0,0,0-12-12,12,12,0,0,0-12,12,12,12,0,0,0,8.1,11.35,1.151,1.151,0,0,0,.618-.894c0-.66-.014-2.358-.014-2.358a8.323,8.323,0,0,1-1.264.089,2.717,2.717,0,0,1-2.747-1.854,3.249,3.249,0,0,0-1.348-1.6c-.311-.2-.382-.435-.023-.5,1.658-.31,2.082,1.87,3.189,2.218a3.114,3.114,0,0,0,2.312-.185,2.391,2.391,0,0,1,.951-1.545c-2.816-.269-4.486-1.242-5.352-2.805l-.093-.175-.218-.5-.064-.178a8.415,8.415,0,0,1-.391-2.718,4.639,4.639,0,0,1,1.323-3.444,4.81,4.81,0,0,1,.208-3.46s1.219-.251,3.523,1.39a12.843,12.843,0,0,1,6.155-.118c.966-.636,2.735-1.538,3.449-1.285a4.468,4.468,0,0,1,.253,3.192,5.575,5.575,0,0,1,1.506,3.977,10.311,10.311,0,0,1-.309,2.469l-.1.352s-.06.166-.124.325l-.076.175c-.835,1.825-2.549,2.506-5.318,2.79.9.562,1.155,1.267,1.155,3.174s-.025,2.163-.02,2.6a1.211,1.211,0,0,0,.594.878A12,12,0,0,0-1098.076,44.932Z"
            transform="translate(1122.076 -32.932)"
            fill="#a0a3a6"
          ></path>
        </svg>
      </a>
    </span>
  );
};

const FacebookSocialIcon = ({ href, companyName, companyId }: IAnyProps) => {
  return (
    <span>
      <a
        className="ps-logo--facebook-logo"
        target="_blank"
        rel="noreferrer"
        href={href}
        data-company-name={companyName}
        data-project-id={companyId}
        data-social-network="facebook"
        data-tracking-id="company-social"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="23.854"
          viewBox="0 0 24 23.854"
        >
          <path
            id="facebook-svg-path"
            data-name="Path 55"
            d="M24,12A12,12,0,1,0,10.125,23.854V15.469H7.078V12h3.047V9.356c0-3.008,1.792-4.669,4.533-4.669a18.453,18.453,0,0,1,2.686.234V7.875H15.831a1.734,1.734,0,0,0-1.956,1.874V12H17.2l-.532,3.469h-2.8v8.385A12,12,0,0,0,24,12Z"
            fill="#a0a3a6"
          ></path>
        </svg>
      </a>
    </span>
  );
};

const MediumSocialIcon = ({ href, companyName, companyId }: IAnyProps) => {
  return (
    <span>
      <a
        className="ps-logo--medium-logo"
        target="_blank"
        rel="noreferrer"
        href={href}
        data-company-name={companyName}
        data-project-id={companyId}
        data-social-network="medium"
        data-tracking-id="company-social"
      >
        <svg
          id="Group_165"
          data-name="Group 165"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <rect
            id="medium-svg-path"
            data-name="Rectangle 328"
            width="24"
            height="24"
            transform="translate(0 0)"
            fill="#a0a3a6"
          ></rect>
          <path
            id="Path_54"
            data-name="Path 54"
            d="M42.512,60.139a.556.556,0,0,0-.193-.479L40.89,58.01v-.246h4.438l3.431,7.208,3.016-7.208h4.231v.246l-1.222,1.122a.336.336,0,0,0-.136.329V67.71a.335.335,0,0,0,.136.329l1.194,1.123v.246h-6v-.246l1.236-1.15c.122-.116.122-.151.122-.329V61.015L47.894,69.38H47.43l-4-8.364v5.606a.753.753,0,0,0,.222.643l1.608,1.869v.246H40.7v-.246l1.608-1.869a.726.726,0,0,0,.207-.643Z"
            transform="translate(-36.488 -51.789)"
            fill="#fff"
          ></path>
        </svg>
      </a>
    </span>
  );
};

const RedditSocialIcon = ({ href, companyName, companyId }: IAnyProps) => {
  return (
    <span>
      <a
        className="ps-logo--reddit-logo"
        target="_blank"
        rel="noreferrer"
        href={href}
        data-company-name={companyName}
        data-project-id={companyId}
        data-social-network="reddit"
        data-tracking-id="company-social"
      >
        <svg width="24" height="24" viewBox="0 0 24 24">
          <path
            id="reddit-svg-path"
            fill="#A0A3A6"
            d="M14.238 15.348c.085.084.085.221 0 .306-.465.462-1.194.687-2.231.687l-.008-.002-.008.002c-1.036 0-1.766-.225-2.231-.688-.085-.084-.085-.221 0-.305.084-.084.222-.084.307 0 .379.377 1.008.561 1.924.561l.008.002.008-.002c.915 0 1.544-.184 1.924-.561.085-.084.223-.084.307 0zm-3.44-2.418c0-.507-.414-.919-.922-.919-.509 0-.923.412-.923.919 0 .506.414.918.923.918.508.001.922-.411.922-.918zm13.202-.93c0 6.627-5.373 12-12 12s-12-5.373-12-12 5.373-12 12-12 12 5.373 12 12zm-5-.129c0-.851-.695-1.543-1.55-1.543-.417 0-.795.167-1.074.435-1.056-.695-2.485-1.137-4.066-1.194l.865-2.724 2.343.549-.003.034c0 .696.569 1.262 1.268 1.262.699 0 1.267-.566 1.267-1.262s-.568-1.262-1.267-1.262c-.537 0-.994.335-1.179.804l-2.525-.592c-.11-.027-.223.037-.257.145l-.965 3.038c-1.656.02-3.155.466-4.258 1.181-.277-.255-.644-.415-1.05-.415-.854.001-1.549.693-1.549 1.544 0 .566.311 1.056.768 1.325-.03.164-.05.331-.05.5 0 2.281 2.805 4.137 6.253 4.137s6.253-1.856 6.253-4.137c0-.16-.017-.317-.044-.472.486-.261.82-.766.82-1.353zm-4.872.141c-.509 0-.922.412-.922.919 0 .506.414.918.922.918s.922-.412.922-.918c0-.507-.413-.919-.922-.919z"
          ></path>
        </svg>
      </a>
    </span>
  );
};

const DiscordSocialIcon = ({ href, companyName, companyId }: IAnyProps) => {
  return (
    <span>
      <a
        className="ps-logo--discord-logo"
        target="_blank"
        rel="noreferrer"
        href={href}
        data-company-name={companyName}
        data-project-id={companyId}
        data-social-network="discord"
        data-tracking-id="company-social"
      >
        <svg
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 245 240"
        >
          <path
            className="ps-svg-path"
            fill="#A0A3A6"
            d="M104.4 103.9c-5.7 0-10.2 5-10.2 11.1s4.6 11.1 10.2 11.1c5.7 0 10.2-5 10.2-11.1.1-6.1-4.5-11.1-10.2-11.1zM140.9 103.9c-5.7 0-10.2 5-10.2 11.1s4.6 11.1 10.2 11.1c5.7 0 10.2-5 10.2-11.1s-4.5-11.1-10.2-11.1z"
          ></path>
          <path
            className="ps-svg-path"
            fill="#A0A3A6"
            d="M189.5 20h-134C44.2 20 35 29.2 35 40.6v135.2c0 11.4 9.2 20.6 20.5 20.6h113.4l-5.3-18.5 12.8 11.9 12.1 11.2 21.5 19V40.6c0-11.4-9.2-20.6-20.5-20.6zm-38.6 130.6s-3.6-4.3-6.6-8.1c13.1-3.7 18.1-11.9 18.1-11.9-4.1 2.7-8 4.6-11.5 5.9-5 2.1-9.8 3.5-14.5 4.3-9.6 1.8-18.4 1.3-25.9-.1-5.7-1.1-10.6-2.7-14.7-4.3-2.3-.9-4.8-2-7.3-3.4-.3-.2-.6-.3-.9-.5-.2-.1-.3-.2-.4-.3-1.8-1-2.8-1.7-2.8-1.7s4.8 8 17.5 11.8c-3 3.8-6.7 8.3-6.7 8.3-22.1-.7-30.5-15.2-30.5-15.2 0-32.2 14.4-58.3 14.4-58.3 14.4-10.8 28.1-10.5 28.1-10.5l1 1.2c-18 5.2-26.3 13.1-26.3 13.1s2.2-1.2 5.9-2.9c10.7-4.7 19.2-6 22.7-6.3.6-.1 1.1-.2 1.7-.2 6.1-.8 13-1 20.2-.2 9.5 1.1 19.7 3.9 30.1 9.6 0 0-7.9-7.5-24.9-12.7l1.4-1.6s13.7-.3 28.1 10.5c0 0 14.4 26.1 14.4 58.3 0 0-8.5 14.5-30.6 15.2z"
          ></path>
        </svg>
      </a>
    </span>
  );
};

const YoutubeSocialIcon = ({ href, companyName, companyId }: IAnyProps) => {
  return (
    <span>
      <a
        className="ps-logo--youtube-logo"
        target="_blank"
        rel="noreferrer"
        href={href}
        data-company-name={companyName}
        data-project-id={companyId}
        data-social-network="youtube"
        data-tracking-id="company-social"
      >
        <svg
          width="20px"
          height="20px"
          viewBox="0 0 16 16"
          version="1.1"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <path
              id="youtube-svg-path"
              data-name="Path 50"
              d="M8.00141201,2 C8.00141201,2 4.64270165,2 2.40324763,2.17258883 C1.79030114,2.18382243 1.21007083,2.44584375 0.802965229,2.89524689 C0.458920366,3.40325241 0.241282827,3.98333453 0.167558981,4.58883249 C0.167558981,4.58883249 0,5.96862021 0,7.35302261 L0,8.64513152 C0,10.0295339 0.16002824,11.4065528 0.16002824,11.4065528 C0.233826654,12.0117472 0.451464118,12.591513 0.795434488,13.0992155 C1.26706342,13.5545547 1.89867515,13.8154699 2.56045184,13.8283341 C3.84067777,13.9593909 8.00141201,14 8.00141201,14 C8.00141201,14 11.3638877,13.9944624 13.6033418,13.8218736 C14.2163671,13.8109779 14.7967292,13.548897 15.2036242,13.0992155 C15.5481799,12.5917226 15.7661647,12.0118904 15.8399718,11.4065528 C15.8399718,11.4065528 16,10.0221504 16,8.64513152 L16,7.35302261 C16,5.96862021 15.8399718,4.59252423 15.8399718,4.59252423 C15.7662049,3.98689124 15.5482228,3.4067503 15.2036242,2.89893862 C14.7967292,2.44925708 14.2163671,2.18717627 13.6033418,2.17628057 C11.3638877,2 8.00141201,2 8.00141201,2 L8.00141201,2 Z M6.37194799,10.3987079 L10.6964758,7.81449008 L6.37194799,5.40470697 L6.37194799,10.3987079 L6.37194799,10.3987079 Z"
              fill="#A0A3A6"
            ></path>
          </g>
        </svg>
      </a>
    </span>
  );
};

const AngellistSocialIcon = ({ href, companyName, companyId }: IAnyProps) => {
  return (
    <span>
      <a
        className="ps-logo--angellist-logo"
        target="_blank"
        rel="noreferrer"
        href={href}
        data-company-name={companyName}
        data-project-id={companyId}
        data-social-network="angellist"
        data-tracking-id="company-social"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 64 64"
          width="22"
          height="22"
        >
          <path
            id="angellist-svg-path"
            data-name="Path 50"
            d="M47.072 27.312q3.964.75 5.58 3.338 1.616 2.6 1.625 8.174 0 11.077-6.66 18.128-6.66 7.05-17.032 7.047a22.022 22.022 0 0 1-7.928-1.471 19.648 19.648 0 0 1-6.607-4.109 20.819 20.819 0 0 1-4.748-6.131 14.878 14.878 0 0 1-1.581-6.607q0-3.78 1.625-5.845Q12.97 37.77 16.48 37a23.519 23.519 0 0 1-.969-2.594 6.307 6.307 0 0 1-.308-1.625q0-1.978 2.088-4.043 2.088-2.066 3.933-2.066a5.404 5.404 0 0 1 1.669.286 10.976 10.976 0 0 1 2.022.947q-3.387-9.58-4.924-14.8-1.537-5.2-1.533-7.18 0-2.726 1.405-4.33a4.845 4.845 0 0 1 3.825-1.59q4.13 0 10.452 18.46 1.097 3.162 1.67 4.88.484-1.36 1.36-3.867Q43.513 1.2 48.08 1.2a4.545 4.545 0 0 1 3.581 1.515q1.32 1.515 1.32 4.065 0 1.934-1.47 7.073-1.47 5.14-4.44 13.468zm-31.47 17.93q.617.75 1.713 2.202 2.902 4 5.36 4a2.33 2.33 0 0 0 1.493-.529 1.453 1.453 0 0 0 .661-1.097q0-.66-.88-2.202a28.373 28.373 0 0 0-2.418-3.471 26.109 26.109 0 0 0-2.924-3.272q-1.163-1.03-1.867-1.03-1.537 0-2.836 1.647a6.104 6.104 0 0 0-1.295 3.889 10.813 10.813 0 0 0 .881 4.021 19.379 19.379 0 0 0 2.616 4.462 17.441 17.441 0 0 0 6.439 5.338 19.185 19.185 0 0 0 8.514 1.85 18.56 18.56 0 0 0 14.349-6.395q5.778-6.395 5.778-16.02a19.872 19.872 0 0 0-.44-4.682 4.479 4.479 0 0 0-1.449-2.528q-1.8-1.493-7.012-2.682a48.822 48.822 0 0 0-10.879-1.185q-1.58 0-2.242.53-.66.53-.66 1.8 0 3 3.338 4.33 3.338 1.34 10.813 1.32h1.8a1.211 1.211 0 0 1 .991.44 2.836 2.836 0 0 1 .507 1.383q-.75.705-3.083 1.603a16.556 16.556 0 0 0-3.559 1.762 15.785 15.785 0 0 0-4.215 4.642 9.804 9.804 0 0 0-1.603 5.034 11.35 11.35 0 0 0 .683 3.493 12.24 12.24 0 0 1 .683 2.528v.308l-.088.396q-1.933-.132-3.052-2.264-1.12-2.132-1.12-5.7v-.396a2.436 2.436 0 0 1-.683.44 1.938 1.938 0 0 1-.727.132 4.048 4.048 0 0 1-.749-.066 7.681 7.681 0 0 1-.793-.198 7.782 7.782 0 0 1 .198.947 5.439 5.439 0 0 1 .066.727 3.651 3.651 0 0 1-1.273 2.792 4.347 4.347 0 0 1-3.035 1.163q-2.77 0-5.624-2.704-2.854-2.704-2.858-5.285a3.043 3.043 0 0 1 .11-.859 1.471 1.471 0 0 1 .37-.639zm13.187 1.053a1.81 1.81 0 0 0 1.361-.683 2.158 2.158 0 0 0 .617-1.471q0-.832-1.207-3.9a38.987 38.987 0 0 0-3.013-5.999 14.037 14.037 0 0 0-2.594-3.316q-1.277-1.12-2.418-1.12-.925 0-2.044 1.163-1.12 1.163-1.12 2.176 0 1.053 1.097 3.162a29.892 29.892 0 0 0 2.947 4.484 24.471 24.471 0 0 0 3.647 4.043q1.713 1.436 2.726 1.436zm4.307-21.23L28.35 11.342q-1.847-5.228-2.85-6.836-1.023-1.606-2.212-1.603a1.832 1.832 0 0 0-1.48.705 2.907 2.907 0 0 0-.573 1.889q0 2.022 1.537 7.047Q24.3 17.57 27.4 25.687a1.467 1.467 0 0 1 .749-.683 3.572 3.572 0 0 1 1.321-.198q.264 0 1.053.044.788.044 2.585.207zM38.06 38.37a27.043 27.043 0 0 1-3.581-.396 18.987 18.987 0 0 1-3.228-.881q.7 1.4 1.25 2.814a24.532 24.532 0 0 1 .881 2.77 21.854 21.854 0 0 1 2.202-2.396 18.564 18.564 0 0 1 2.475-1.911zm5.845-11.82q2.942-7.998 4.594-13.213 1.652-5.215 1.647-6.395a3.145 3.145 0 0 0-.551-1.978 1.819 1.819 0 0 0-1.515-.705q-1.23 0-2.506 2.044-1.277 2.044-2.814 6.57l-4.404 12.702z"
            fill="#a0a3a6"
          ></path>
        </svg>
      </a>
    </span>
  );
};

const CrunchbaseSocialIcon = ({ href, companyName, companyId }: IAnyProps) => {
  return (
    <span>
      <a
        className="ps-logo--crunchbase-logo"
        target="_blank"
        rel="noreferrer"
        href={href}
        data-company-name={companyName}
        data-project-id={companyId}
        data-social-network="crunchbase"
        data-tracking-id="company-social"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          role="img"
          viewBox="0 0 24 24"
          width="22"
          height="22"
        >
          <path
            id="crunchbase-svg-path"
            d="M21.6 0H2.4A2.41 2.41 0 0 0 0 2.4v19.2A2.41 2.41 0 0 0 2.4 24h19.2a2.41 2.41 0 0 0 2.4-2.4V2.4A2.41 2.41 0 0 0 21.6 0zM7.045 14.465A2.11 2.11 0 0 0 9.84 13.42h1.66a3.69 3.69 0 1 1 0-1.75H9.84a2.11 2.11 0 1 0-2.795 2.795zm11.345.845a3.55 3.55 0 0 1-1.06.63 3.68 3.68 0 0 1-3.39-.38v.38h-1.51V5.37h1.5v4.11a3.74 3.74 0 0 1 1.8-.63H16a3.67 3.67 0 0 1 2.39 6.46zm-.223-2.766a2.104 2.104 0 1 1-4.207 0 2.104 2.104 0 0 1 4.207 0z"
            fill="#a0a3a6"
          ></path>
        </svg>
      </a>
    </span>
  );
};
